import { useEffect } from "react";
import Permission from "../../auth/Permission";

export type ActionItem = {
  label: string,
  action: (data: unknown) => unknown,
  disabled?: (data: unknown) => boolean,
  visible?: (data: unknown) => boolean,
  permission?: string,  // Permissão original
  role?: string        // Adicionando suporte a role
};

type Props = {
  open: boolean
  actions: ActionItem[]
  data: unknown
  onClose: () => unknown
}

function PopoverList(props: Props) {
  const { open, onClose } = props
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.closest('.context-menu') === null) {
        onClose();
      }
    }

    open
      ? document.addEventListener("mousedown", handleClickOutside)
      : document.removeEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleAction = (action: (data: unknown) => void) => {
    action(props.data)
    onClose()
  }

  return (
    <div className="context-menu absolute right-5 top-2">
      <div className="shadow bg-white rounded w-32 flex flex-col p-2">
        {props.actions
          .filter(action => action.visible ? action.visible(props.data) : true)
          .map(({ label, disabled, action, permission, role }) => (
            <Permission permission={permission} role={role} key={label}>
              <button
                disabled={disabled && disabled(props.data)}
                onClick={() => handleAction(action)}
                className="rounded-none px-1 py-1 dark:bg-white dark:text-black hover:bg-redPrimary hover:text-white disabled:bg-transparent dark:disabled:bg-transparent disabled:text-gray"
              >
                {label}
              </button>
            </Permission>
          ))}
      </div>
    </div>
  );
}

export default PopoverList;